import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography
} from '@mui/material'
import React from 'react'

import { KubernetesListItemTags } from 'components/services/create/target-selection/kubernetes/KubernetesListItemTags'
import { K8sAutocompleteSearchOption } from 'types/forms'

export const KubernetesTagLabelSectionListItem = React.forwardRef<
  HTMLDivElement,
  {
    option: K8sAutocompleteSearchOption
    isLastOption: boolean
    isSelected: boolean
    handleSelectOption(e, option): void
  }
>(({ option, isLastOption, isSelected, handleSelectOption, ...rest }, ref) => {
  const { label, tags, uid } = option

  return (
    <Box {...rest} ref={ref}>
      <Grid container alignItems="center" sx={{ padding: 1 }}>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isSelected}
                data-test-target-option={label || uid}
                data-test-target-param-value={label || uid}
                inputProps={
                  {
                    'data-testid': `kubernetes-target-checkbox-${label}-${uid}`
                  } as React.InputHTMLAttributes<HTMLInputElement>
                }
                onChange={(e) => handleSelectOption(e, option)}
              />
            }
            label={
              <Typography color="text.secondary" variant="body2">
                {label}
              </Typography>
            }
          />
        </Grid>
        <Grid item display="flex" justifyContent="flex-end" xs={6}>
          <KubernetesListItemTags isSelected={isSelected} tags={tags} />
        </Grid>
      </Grid>
      {!isLastOption && (
        <Divider data-test-kubernetes-tag-label-list-item-divider />
      )}
    </Box>
  )
})
